export const weightLoss = {
  program: 'Programa {{program}}',
  shareYourGoals: 'Construya su perfil de pérdida de peso con una evaluación rápida',
  personalizeMedication: 'Personaliza tu medicación y programa para que se adapten a tus metas.',
  step: 'Paso',
  yourGoals: 'Tus metas',
  goal: 'Meta',
  yourCurrentHealth: 'Tu salud actual',
  months: 'meses',
  loseUpTo: 'Pierde hasta',
  averageWeight:
    '*La pérdida de peso promedio según estudios clínicos de 68 y 72 semanas sobre Semaglutida (2.4 mg) y Tirzepatida (10-15 mg) en pacientes sin diabetes y con un IMC ≥30, o IMC ≥27 con una condición de salud relacionada con el peso, la pérdida de peso promedio fue del 15% y 20% respectivamente.',
  letsConnect:
    '{{ name }}, ¡conectémonos con tu equipo médico para encontrar el programa de pérdida de peso más seguro para ti!',
  meetWithMedicalTeam: 'Reunámonos con tu equipo médico para tu consulta personalizada.',
  weReview: 'Revisaremos tu IMC y factores de riesgo. Por favor, elige un momento conveniente para reunirte.',
  withMedicalTeam: 'Durante su consulta, personalizaremos su programa:',
  glp: 'Opciones de medicación GLP-1',
  coaching: 'Entrenamiento en salud y bienestar',
  oneOnOne: 'Soporte médico 1-a-1',
  getStarted: '¿Listo para comenzar?',
  primeWeightLoss: 'Suscripción {{program}}',
  perMonth: 'Por mes',
  confirmSub:
    'Al confirmar tu suscripción, permites que Next Level Medical te cobre futuros pagos de acuerdo con sus términos. Siempre puedes cancelar tu suscripción.',
  yourVisit: 'Tu visita con',
  programReviewReady:
    'El programa {{program}} del que hemos discutido está listo para su revisión. Si todo parece correcto, suscríbete hoy para comenzar.',
  planReviewReady: '¡Tu plan personalizado de pérdida de peso está listo para revisión!',
  subConfirmed: '¡Tu suscripción a {{program}} está confirmada!',
  weNotify: 'Te notificaremos cuando tu medicamento haya sido enviado para su entrega.',
  weCharge: 'Cobraremos {{ currency }}{{ price }} el ',
  weChargeMonth: '{{ day }} de ',
  day: 'día',
  week: 'semana',
  month: 'mes',
  year: 'año',
  every: 'cada ',
  everyInterval: 'cada {{ interval }} ',
  yourPrescription: 'Tu receta ha sido solicitada.',
  subscribe: 'Suscribirse',
  subscriptionPayment: 'Pago de suscripción',
  followUp: 'Hagamos un seguimiento de tu progreso de pérdida de peso para {{ month }}, {{ name }}.',
  medialTeamReady: 'Tu equipo médico está listo para revisar y renovar tu receta.',
  prescription: 'Tu receta y dosificación',
  weekly: '{{ amount }} semanal',
  tirzepatide: 'Tirzepatida',
  prescriptionDelivery: 'Entrega de tu receta',
  estimatedDelivered: 'Se estima que tu receta será entregada para',
  workingDays: '{{ date }} días hábiles.',
  manage: 'Gestiona cómo te sientes, incluyendo efectos secundarios',
  adjustMedication: 'Ajusta la dosificación de tu medicación según sea necesario',
  pleaseChoose: 'Por favor, elige un momento que te convenga.',
  now: 'Ahora',
  noSlots: 'Todas las citas están ocupadas para esta fecha. Seleccione otro día.',
  linkForJoin: 'Te enviaremos un enlace para unirte a la sala de espera en línea en:',
  interestedIn: '¿Interesado en obtener acceso? Hazle saber a tu empleador que te gustaría obtener más información.',
  notSurePrimeStatus: '¿No estás seguro de tu estado Prime?',
  allSetAccess: 'Asegurémonos de que estés listo para acceder a tu membresía.',
  calcData: 'Un momento, estamos obteniendo tus datos',
  addressYourConcerns:
    'Aborda tus preocupaciones, monitorea los efectos secundarios y asegúrate de que tu salud se mantenga en buen camino.',
  getExpertTips:
    'Obtén consejos de expertos sobre actividad y nutrición para mantenerte motivado y acercarte a tus metas de pérdida de peso, paso a paso.',
  receiveMentaEmotionalsupport:
    'Recibe el apoyo emocional y de salud mental que necesitas para sentirte seguro y respaldado a lo largo de tu camino.',
  currentlyEnrolled:
    'Esta persona ya está inscrita en el programa médico de pérdida de peso. Por favor, seleccione otro paciente para inscribir.',
  timeSlotNoAvailable: 'Este horario ya no está disponible. Por favor, seleccione otro.',
  pleaseConfirmAddress: 'Confirma tu dirección de envío para la próxima entrega de tu medicamento.',
  title: {
    excitedToBuild:
      '¡Hola {{ name }}! Estamos emocionados de construir un programa de pérdida de peso personalizado contigo.',
    exclusivelyPrimeMembers:
      'Nuestro programa {{program}} está disponible exclusivamente para los miembros de Next Level Prime.',
    whatWouldYouLike: '¿Qué te gustaría ',
    achieve: 'lograr ',
    withTheProgram: 'con el programa?',
    whatIsYour: '¿Cuál es tu ',
    currentWeight: 'peso actual',
    currentHeight: 'altura actual',
    yourPotentialWeightLoss: 'Tu pérdida de peso potencial',
    combinedWithGlp: 'Con GLP-1 y nuestro programa, verás un progreso significativo hacia tus objetivos en solo ',
    threeMonths: '3 meses',
    calculatingWeight: 'Un momento, estamos calculando tu posible pérdida de peso...',
    estimatedMilestones: 'Tus hitos estimados basados en tratamientos de pérdida de peso clínicamente probados*',
    connectMedicalTeam: 'Conéctate con tu equipo médico',
    planBuild: 'Felicitaciones. ¡Usted encaja perfectamente en nuestro programa!',
    medicationOptions: 'Opciones de medicación que discutirás:',
    potentialWeightLoss: 'Tu pérdida de peso potencial',
    sendingResponses: 'Gracias, {{ name }}. Estamos creando tu perfil de pérdida de peso ahora...',
    needMoreInfo: '¿Necesitas más información antes de suscribirte?',
    yourSub: 'Tu suscripción',
    personalizedPlan: 'Plan personalizado de pérdida de peso',
    glp: 'Medicación GLP-1',
    labs: 'Laboratorios',
    medicalSupport: 'Soporte médico',
    nutrition: 'Nutrición y ejercicio',
    thankYou: 'Gracias por reunirte conmigo, {{ name }}.',
    congrats: '¡Felicidades, {{ name }}! Has sido suscrito a tu plan {{program}}.',
    weightLossSummary: 'Aquí está tu resumen de pérdida de peso para agosto, {{ name }}.',
    meetMedicalTeam: '¿Te gustaría reunirte con tu equipo médico hoy?',
    letsMeet: 'Reunámonos con tu equipo médico para tu consulta personal.',
    topicsCover: 'Temas que cubriremos durante tu consulta:',
    sendingOff: 'Enviando a tu equipo médico ahora...',
    checkIn: 'Revisión mensual',
    allSet: '¡Todo listo!',
    visitStarting: 'Le informamos a su equipo médico de pérdida de peso que ha llegado...',
    primeWeight: 'El programa {{program}} es',
    exclusive: 'exclusivo',
    toOurPrimeMembers: 'a pacientes de Next Level en Texas.',
    interestedInWl:
      '¿Está interesado en un programa de pérdida de peso con todo incluido y diseñado exclusivamente para usted?',
    newLinkSent: 'Se ha enviado un nuevo enlace seguro a {{ contact }}',
    didntRecieveLink: '¿No recibiste un nuevo enlace?',
    meetYourMedicalTeam: 'Reúnete con tu equipo médico',
    meetYourHealthCoach: 'Reúnete con tu entrenador de salud',
    meetYourWellnessCounselor: 'Reúnete con tu consejero de bienestar',
    nextMeetTeam: 'A continuación, reúnase con su equipo médico para personalizar y confirmar su medicación.',
    selectTime: 'Por favor, seleccione su fecha y hora preferidas.',
    confirmTime: 'Por favor, revise y confirme la fecha y hora de su visita.',
    monthGoal: 'meta del mes',
    alreadyInProgram: 'Ya está en el programa',
    frontDoorUnavailable: '¡Lo siento! Actualmente no estamos disponibles.',
    primeMembers: 'Miembros Prime',
    pleaseConfirmAddress: 'Por favor, confirma tu dirección de envío para la entrega a domicilio.',
    selectAddress: 'Selecciona tu dirección de envío para la entrega a domicilio.',
  },
  subtitle: {
    glp: '{{ medicationName }}, {{ dosageInstruction }}',
    deliveredMonthly: 'Entrega mensual',
    labs: 'Inicial y seguimientos según sea necesario',
    medicalSupport: 'Guía de salud personalizada cada mes',
    nutrition: 'Acceso a nutrición y coaching de bienestar a demanda',
    needSupport: '¿Necesitas apoyo? Estamos aquí para ti.',
    upcomingVisit: 'Próxima visita',
    for: 'Para',
  },
  actions: {
    getStarted: 'Comenzar',
    continue: 'Continuar',
    next: 'Siguiente: tu historial de salud',
    moreTimes: 'Más horarios',
    schedule: 'Programar una consulta',
    callUs: 'Llámanos',
    subscribe: 'Suscribirse',
    manageSubscription: 'Gestionar Mi Suscripción',
    done: 'Hecho',
    returnHome: 'Volver a casa',
    contactSupport: 'Contactar soporte',
    explorePrimeBenefits: 'Explorar beneficios Prime',
    subscribeNow: 'Suscribirse ahora',
    billedMonthly: 'Facturado {{ period }}, cancela en cualquier momento.',
    goHome: 'Ir a casa',
    resendLink: 'Reenviar enlace',
    linkSent: 'Enlace enviado',
    scheduleNow: 'Programa ahora',
    chat: 'Chat',
    call: 'Llamar',
    seeOtherTimes: 'Ver otros horarios',
    getInLineNow: 'Ponte en la fila ahora',
    meetAt: 'Reunámonos a las',
    teamAvailable: '¡Nuestro equipo médico está disponible ahora!',
    confirm: 'Confirmar',
    edit: 'Editar',
    backToSchedule: 'Volver al horario',
    selectAnotherPerson: 'Seleccionar otra persona',
    manageSubs: 'Gestiona tu suscripción',
    changeAddress: 'Cambiar dirección de envío',
    addNewAddress: 'Agregar nueva dirección de envío',
  },
  aria: {
    previousDay: 'Día anterior',
    nextDay: 'Día siguiente',
    confirm: 'Confirmar',
    selectAnotherPerson: 'Seleccione otra persona',
    takePhoto: 'Tomar foto',
  },
  steps: {
    yourGoals: 'Tus metas',
    currentHealth: 'Tu salud actual',
    healthHistory: 'Tu historial de salud',
  },
  error: {
    failedToLoadShippingAddress: 'No se pudo cargar la dirección de envío',
    failedToSelectShippingAddress: 'No se pudo seleccionar la dirección de envío',
    invalidShippingAddress: 'La dirección de envío no es válida. Por favor, selecciona o agrega una diferente',
    failedToLoadOffer: 'Error al cargar la oferta',
  },
  today: 'Hoy',
  tomorrow: 'Mañana',

  pill: {
    weightLoss: 'Next Level Pérdida de peso',
  },
};
